import { render, staticRenderFns } from "./eod-scheduler-sidebar-item.vue?vue&type=template&id=5b346206&scoped=true"
import script from "./eod-scheduler-sidebar-item.vue?vue&type=script&lang=js"
export * from "./eod-scheduler-sidebar-item.vue?vue&type=script&lang=js"
import style0 from "./eod-scheduler-sidebar-item.vue?vue&type=style&index=0&id=5b346206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b346206",
  null
  
)

export default component.exports